import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import _ from 'underscore';
import { initUrlParams, stringifySearch } from '../../../../../utils';
import { mpSearchData } from '../../../../../utils/mp_search_data';
import styles from './index.module.scss';

function BtmFilter() {

  const history = useHistory();
  const { pathname } = useLocation();
  const {
    urlParams,
  } = useSelector(state => state.searchReducer);

  const [isStock, setIsStock] = useState(false);
  const [isJDL, setIsJDL] = useState(false);
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    if (!urlParams) return;
    setInputValue(urlParams?.searchkey || '')
    urlParams.stock ? setIsStock(!!Number(urlParams.stock)) : setIsStock(false);
    urlParams.delivery ? setIsJDL(!!Number(urlParams.delivery)) : setIsJDL(false);
  }, [urlParams])

  const handleStockClick = () => {
    const _searchParamsBody = JSON.parse(JSON.stringify(urlParams));
    // initUrlParams(_searchParamsBody)
    setIsStock(!isStock)
    _searchParamsBody.stock =  Number(!isStock);
    history.push({
      pathname,
      search: stringifySearch(_searchParamsBody)
    })
  };
  
  const handleJDLClick = () => {
    const _searchParamsBody = JSON.parse(JSON.stringify(urlParams));
    // initUrlParams(_searchParamsBody, true)
    setIsJDL(!isJDL)
    _searchParamsBody.delivery = Number(!isJDL);
    history.push({
      pathname,
      search: stringifySearch(_searchParamsBody)
    })
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
  }

  const handleInputOk = () => {
    const _searchParamsBody = JSON.parse(JSON.stringify(urlParams))
    if(!_searchParamsBody.searchkey && inputValue !== ''){
      // initUrlParams(_searchParamsBody, true)
      _searchParamsBody.searchkey = inputValue
      history.push({
        pathname,
        search: stringifySearch(_searchParamsBody)
      })
    } else if (!!_searchParamsBody.searchkey){
      // initUrlParams(_searchParamsBody, true)
      delete  _searchParamsBody.searchkey;
      history.push({
        pathname,
        search: stringifySearch(_searchParamsBody)
      })
    }
  }

  return (
    <div className={`${styles["f-line"]} ${styles.btm}`}>
      {/* <div className="f-store">
        <div className="fs-cell delivery-location">配送至</div>
        <div id="store-selector">
          <div className="text">北京市朝阳区<b></b></div>
          <div className="content">
            <div className="m JD-stock">
              <div className="mt">
                <ul className="tab">
                  <li data-idx="0" className="curr">
                    <a href='javascript:;'>
                      <em>请选择</em>
                    </a>
                  </li>
                  <li data-idx="1">
                    <a href='javascript:;'>
                      <em>请选择</em>
                    </a>
                  </li>
                  <li data-idx="2">
                    <a href='javascript:;'>
                      <em>请选择</em>
                    </a>
                  </li>
                </ul>
                <div className="stock-line"></div>
              </div>
              <div className="mc" data-area="0">
                <ul className="area-list"></ul>
              </div>
              <div className="mc hide" data-area="1">
                <ul className="area-list"></ul>
                <p className="ac">请选择一级地区...</p>
              </div>
              <div className="mc hide" data-area="2">
                <ul className="area-list"></ul>
                <p className="ac">请选择二级地区...</p>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div className={styles["f-feature"]}>
        <ul>
          <li onClick={handleStockClick} clstag={mpSearchData.filter.stock}>
            <span className={isStock ? `${styles.selected}` : null}><i></i>仅显示有货</span>
          </li>
          <li onClick={handleJDLClick} clstag={mpSearchData.filter.delivery}>
            <span className={isJDL ? `${styles.selected}` : null}><i></i>京东物流</span>
          </li>
          {/* <li>
            <span><i></i>商品促销</span>
          </li> */}
        </ul >
      </div >
      <div className={styles["f-search"]}>
        <input id="resultSearchTxt" placeholder="在结果中搜索"
          value={inputValue}
          onChange={handleInputChange}
          className={styles["input-txt"]} />
        <button className={styles.btn} onClick={handleInputOk}>{urlParams.searchkey ? '取消' : '确定'}</button>
      </div>
      {/* ##直接搜索店铺内商品时，不显示切换维度按钮
      ##if($!conmmonData.showVt)
      ## < div className="f-viewType" >
        ## < a href="$!conmmonData.shopViewUrl" className="ft-item #if($!conmmonData.vtSelected)curr#end" clstag="firsttype|keycount|jdworldwidesearchlist|vtshop" >
          ## < i className="i-shop" ></i > 店铺
          ##</a >
        ## < a href="$!conmmonData.goodsViewUrl" className="ft-item #if(!$!conmmonData.vtSelected)curr#end" clstag="firsttype|keycount|jdworldwidesearchlist|vtitem" >
          ## < i className="i-item" ></i > 商品
          ##</a >
        ##</div >
      ##end */}
      <span className="clr" ></span>
    </div >
  )
};

export default BtmFilter;